import { theme } from 'aimo-ui';
import Icon from 'components/icons/Icon';
import React from 'react';

export const InfoIcon = () => (
  <Icon color={theme.colors.aimoUiRed} name="Info-Filled" />
);

export const InfoIconOutlined = () => (
  <Icon color={theme.colors.aimoUiRed} name="Info-Outlined" />
);
export default InfoIcon;
